/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Ai_3Inputs */

const da_privacy_ai_3 = /** @type {(inputs: Privacy_Ai_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI kan tage fejl og træffer ingen afgørelser: du gennemgår og godkender altid selv resultatet. Vi vælger udbydere, der ikke bruger indholdet til at træne deres modeller.`)
};

/** @type {(inputs: Privacy_Ai_3Inputs) => LocalizedString} */
const en_privacy_ai_3 = da_privacy_ai_3;

/**

* @param {Privacy_Ai_3Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_ai_3 = /** @type {((inputs?: Privacy_Ai_3Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Ai_3Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_ai_3(inputs)
	return /** @type {LocalizedString} */ ("AI kan tage fejl og træffer ingen afgørelser: du gennemgår og godkender altid selv resultatet. Vi vælger udbydere, der ikke bruger indholdet til at træne deres modeller.")
});